<script lang="ts" setup>
import { useModule } from "@/stores/module";
import { computed, onMounted, ref } from "vue";
import { BG_STORY_MODULE_ID } from "@/stores/module/moduleMate";
import { useI18n } from "vue-i18n";
import ModalSelectStorybook from "@/components/mobile/common/entity/ModalSelectStorybook.vue";
import { useStoryBook } from "@/stores/story-book";
import { showConfirmDialog } from "vant";
const moduleStore = useModule();
defineProps({
  isSaving: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:isSaving"]);
const fields = computed(() => {
  return moduleStore.module!.moduleFieldsMap[BG_STORY_MODULE_ID];
});

const store = useStoryBook();
const { t } = useI18n();

const updateBgStory = async (content: string, index: number) => {
  fields.value[index].value = content;
  emit("update:isSaving", true);
  await moduleStore.updateMateModule(BG_STORY_MODULE_ID);
  emit("update:isSaving", false);
};

const showStorybookPicker = ref(false);

const hasStorybook = computed(() => {
  return (
    fields.value[1].value &&
    store.allStoryBookList.find(
      (item) => item.id === Number(fields.value[1].value)
    )
  );
});

const onStorybookSelected = (storybook: StoryBook) => {
  showStorybookPicker.value = false;
  updateBgStory(String(storybook.id), 1);
};

const clickDeleteStorybook = () => {
  showConfirmDialog({
    title: t("Message.deleteConfirm"),
    confirmButtonText: t("Buttons.confirm"),
    cancelButtonText: t("Buttons.cancel"),
  }).then(() => {
    updateBgStory("", 1);
  });
};

let isInit = ref(false);
onMounted(async () => {
  isInit.value = false;
  await store.getStoryBookList(true);
  isInit.value = true;
});
</script>
<template>
  <div class="w-full flex flex-col gap-2 py-4">
    <div>
      <div v-if="!isInit" class="flex justify-center items-center mt-5">
        <div class="loading loading-ring loading-lg" />
      </div>
      <VanCellGroup v-else inset>
        <CustomRichTextCell
          :title="$t('User.mate.bgStory.personalExperience')"
          :module-name="$t('User.mate.module.bgStory')"
          :content="fields[0].value"
          :cb="(content:string) => updateBgStory(content, 0)"
        />

        <VanCell>
          <div class="flex gap-2 justify-between items-center">
            <div class="van-field__label">
              {{ $t("User.mate.bgStory.relatedStorybook") }}
            </div>

            <div class="flex gap-2">
              <button
                class="btn btn-xs btn-outline"
                @click="showStorybookPicker = true"
              >
                <i
                  :class="[
                    'iconify',
                    hasStorybook ? 'mdi--swap-horizontal' : 'mdi--plus',
                  ]"
                />
              </button>

              <button
                v-if="hasStorybook"
                class="btn btn-xs btn-outline"
                @click="clickDeleteStorybook"
              >
                <i class="iconify mdi--delete" />
              </button>
            </div>
          </div>
          <story-list-item
            v-if="hasStorybook"
            :story="store.allStoryBookList.find(
                (item) => item.id === Number(fields[1].value)
              )!
            "
          />
        </VanCell>
      </VanCellGroup>
    </div>

    <ModalSelectStorybook
      v-model:show="showStorybookPicker"
      :exclude="[]"
      @selected="onStorybookSelected"
    />
  </div>
</template>
